<div class="categories-page">
  <!-- Page Header Section -->
  <div class="page-header-section">
    <div class="header-left">
      <div class="backButton" (click)="builderService.navigateBack()">
        <img src="/assets/icons/arrow-left.svg" [alt]="'Go back' | translate" />
      </div>
      <h1 class="page-title">{{ 'Categories' | translate }}</h1>
      <p class="page-subtitle">{{ 'Organize your products into structured groups and hierarchies.' | translate }}</p>
    </div>
    <div class="header-right" *ngIf="!this.vendor.vendorsList.length">
      <button class="btn-add-category" (click)="addCategory()">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7 2.91675V11.0834M2.91667 7.00008H11.0833" stroke="currentColor" stroke-width="1.225" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        {{ 'Add Category' | translate }}
      </button>
      <button class="btn-save" (click)="saveCategories()" [disabled]="!saveState">
        {{ 'Save' | translate }}
      </button>
    </div>
  </div>

  <!-- Categories Summary Cards -->
  <div class="categories-summary">
    <div class="summary-card" *ngFor="let card of categorySummary">
      <div class="icon">
        <img [src]="'assets/icons/' + card.icon" alt="{{ card.title | translate }}" />
      </div>
      <div class="card-content">
        <div class="card-header-row">
          <p>{{ card.title | translate }}</p>
          <div class="card-count">
            <strong>{{ card.count }}</strong>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Categories List Container -->
  <div class="categories-list-container">
    <!-- Category Cards -->
    <div class="category-card" *ngFor="let cat of displayedCategories; let i = index" [class.expanded]="expandedCategories[i]">
      <!-- Category Header Row -->
      <div class="category-header-row">
        <div class="category-left">
          <!-- Category Image (clickable for upload) -->
          <label class="category-image-wrapper">
            <input type="file" (change)="onCatFileSelected($event, cat, i, 0, 'category')" accept="image/*" />
            <div class="category-image">
              <img *ngIf="cat?.categoryImage" [src]="cat?.categoryImage" alt="" />
              <img *ngIf="!cat?.categoryImage" src="assets/images/empty-image.png" alt="" />
              <!-- Dark overlay with upload icon on hover -->
              <div class="image-overlay">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M14 10V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V10M11.3333 5.33333L8 2M8 2L4.66667 5.33333M8 2V10" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
            </div>
            <mat-progress-bar mode="determinate" [value]="builderService.fileUploadProgress" *ngIf="showUploadProgress[i]" class="image-upload-progress"></mat-progress-bar>
          </label>
          <!-- Category Info -->
          <div class="category-info">
            <div class="category-name-row">
              <input
                type="text"
                class="category-name-input"
                [(ngModel)]="cat.categoryName"
                placeholder="{{ 'New Category' | translate }}"
                [class.editing]="editingCategoryIndex === i"
                (blur)="editingCategoryIndex = -1"
                (ngModelChange)="saveState = true"
              />
              <button *ngIf="!cat.isNew" class="edit-icon-btn" (click)="focusCategoryName(i)">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6.5 2L10 5.5M1 11L1.83333 8.16667C1.86837 8.04914 1.88589 7.99038 1.91296 7.93634C1.93706 7.88858 1.96625 7.84352 2 7.80167C2.03815 7.75473 2.08416 7.71372 2.17619 7.63171L7.92929 2.47487C8.26293 2.17643 8.42975 2.02721 8.61992 1.97387C8.78724 1.9268 8.96558 1.93361 9.12889 1.99336C9.31376 2.06123 9.46968 2.22356 9.78153 2.54822L9.90942 2.68145C10.2413 3.02709 10.4073 3.19991 10.4657 3.39694C10.517 3.57072 10.5066 3.75686 10.4362 3.92417C10.3557 4.11463 10.1738 4.26913 9.81006 4.57814L4.04761 9.47333C3.96125 9.54668 3.91807 9.58335 3.8698 9.61236C3.82679 9.63816 3.78059 9.6588 3.73224 9.67383C3.67761 9.69082 3.61981 9.69823 3.50421 9.71305L1 10L1 11Z" stroke="#ADADAD" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
            </div>
            <span class="subcategory-count">{{ cat.subcategories?.length || 0 }} {{ 'sub-categories' | translate }}</span>
          </div>
        </div>

        <div class="category-right">
          <button class="btn-add-subcategory" (click)="addSub(cat); $event.stopPropagation()" *ngIf="!this.vendor.vendorsList.length">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8 3.33325V12.6666M3.33333 7.99992H12.6667" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            {{ 'Add Sub-category' | translate }}
          </button>
          <button class="btn-trash" (click)="openDeleteModal('category', i); $event.stopPropagation()">
            <svg width="15.6" height="15.6" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2 4H14M12.6667 4V13.3333C12.6667 14 12 14.6667 11.3333 14.6667H4.66667C4 14.6667 3.33333 14 3.33333 13.3333V4M5.33333 4V2.66667C5.33333 2 6 1.33333 6.66667 1.33333H9.33333C10 1.33333 10.6667 2 10.6667 2.66667V4" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
          <!-- Arrow always visible -->
          <button class="btn-expand" (click)="handleExpandClick(i)">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" [class.rotated]="expandedCategories[i]">
              <path d="M3.5 5.25L7 8.75L10.5 5.25" stroke="currentColor" stroke-width="0.7875" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
      </div>

      <!-- Subcategories List (expandable) -->
      <div class="subcategories-section" *ngIf="expandedCategories[i]">
        <!-- Empty state message when no subcategories -->
        <div class="no-subcategories-message" *ngIf="!cat.subcategories || cat.subcategories.length === 0">
          {{ 'No sub-categories for this category' | translate }}
        </div>
        <div class="subcategory-row" *ngFor="let sub of cat.subcategories; let j = index">
          <div class="subcategory-left">
            <!-- Subcategory Image (clickable for upload) -->
            <label class="subcategory-image-wrapper">
              <input type="file" (change)="onCatFileSelected($event, sub, i, j, 'subcategory')" accept="image/*" />
              <div class="subcategory-image">
                <img *ngIf="sub?.categoryImage" [src]="sub?.categoryImage" alt="" />
                <ng-container *ngIf="!sub?.categoryImage">
                  <div class="empty-image-placeholder">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M10.5 7.5V10.5H1.5V7.5M6 1.5V8.5M6 8.5L3 5.5M6 8.5L9 5.5" stroke="#ADADAD" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </div>
                </ng-container>
                <!-- Dark overlay with upload icon on hover -->
                <div class="image-overlay">
                  <svg width="12" height="12" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 10V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V10M11.3333 5.33333L8 2M8 2L4.66667 5.33333M8 2V10" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
              </div>
            </label>
            <!-- Subcategory Name Input -->
            <div class="subcategory-name-wrapper" [class.invalid]="sub.invalid">
              <input
                type="text"
                class="subcategory-name-input"
                [class.invalid]="sub.invalid"
                [(ngModel)]="sub.subcategory"
                placeholder="{{ 'Sub Category Name' | translate }}"
                (blur)="saveState = true"
                (ngModelChange)="saveState = true"
              />
            </div>
            <!-- Delete button right next to subcategory name -->
            <button class="btn-trash-sub" (click)="openDeleteModal('subcategory', cat, j)">
              <svg width="15.6" height="15.6" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 4H14M12.6667 4V13.3333C12.6667 14 12 14.6667 11.3333 14.6667H4.66667C4 14.6667 3.33333 14 3.33333 13.3333V4M5.33333 4V2.66667C5.33333 2 6 1.33333 6.66667 1.33333H9.33333C10 1.33333 10.6667 2 10.6667 2.66667V4" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Empty State -->
    <div class="empty-state" *ngIf="categories.length === 0">
      <p class="no-categories">{{ 'No categories yet' | translate }}</p>
      <button class="btn-add-category" (click)="addCategory()" *ngIf="!this.vendor.vendorsList.length">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7 2.91675V11.0834M2.91667 7.00008H11.0833" stroke="currentColor" stroke-width="1.225" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        {{ 'Add Category' | translate }}
      </button>
    </div>
  </div>

  <!-- Pagination -->
  <div class="pagination-section" *ngIf="categories.length > 0">
    <div class="pagination-pageSize">
      <span class="pageSize-label">{{ 'Items per page' | translate }}:</span>
      <select class="pageSize-select" [(ngModel)]="pageSize" (change)="changePageSize(pageSize)">
        <option *ngFor="let size of [5, 10, 20, 50, 100]" [value]="size">{{ size }}</option>
      </select>
    </div>
    <div class="pagination-controls">
      <div class="pagination-pages">
        <span class="current-page">{{ pageIndex + 1 }}</span>
        <span class="page-separator">of</span>
        <span class="total-pages">{{ Math.ceil(categories.length / pageSize) || 1 }}</span>
      </div>
      <div class="pagination-buttons">
        <button class="page-btn prev" [disabled]="pageIndex === 0" (click)="previousPage()">
          <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.25 7.5L3.75 5L6.25 2.5" stroke="currentColor" stroke-width="0.625" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </button>
        <button class="page-btn next" [disabled]="pageIndex >= Math.ceil(categories.length / pageSize) - 1" (click)="nextPage()">
          <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.75 7.5L6.25 5L3.75 2.5" stroke="currentColor" stroke-width="0.625" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </button>
      </div>
    </div>
  </div>

  <!-- Hidden Mat Paginator -->
  <mat-paginator class="hidden-paginator" [length]="categories.length" [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 20, 50, 100]" showFirstLastButtons (page)="onPageChange($event)"></mat-paginator>

  <!-- Admin Backup -->
  <div class="backup-section" *ngIf="categories.length > 0 && this.loginService.getCurrentUser().admin">
    <app-backup backupNode="categories"></app-backup>
  </div>
</div>

<app-delete-confirm-modal
  [visible]="showDeleteModal"
  [itemName]="deleteItemName"
  [itemType]="deleteItemType"
  (confirmed)="confirmDelete()"
  (cancelled)="closeDeleteModal()">
</app-delete-confirm-modal>
